<!--
 * @Description: 招股书
 * @Author:  单珊珊
 * @Date: 2022-02-15 09:51:10
 * @LastEditTime: 2022-05-06 16:22:47
 * @LastEditors:  
-->
<template>
  <div class="app">
    <div class="header">
      <div class="left title-underline">招股书</div>
      <div class="right">招股书由<img :src="$store.state.static_img_url+'pic/logo.png'" @click="haddleApplyTry2(32)">提供支持</div>
    </div>
    <div class="porspectus-list">
      <div class="porspectus-item" v-for="item, index in list" :key="index">
        <div class="line1">
          <div class="name l1-ellipsis">{{item.name}}</div>
          <a class="browser"
          v-if="item.file_path"
          :href="item.src_url ? item.src_url : $store.state.static_pdf_url + item.file_path.substr(1)"
          onclick="_czc.push(['_trackEvent', '看赛道(新)', '招股书(查看), '点击量'])"
          target="_blank" download>查看</a>
          <a class="browser" v-else-if="item.src_url" :href="item.src_url" target="_blank">报道</a>
          <a class="browser" v-else>暂无</a>
        </div>
        <div class="line-detail">
          <div class="company">{{item.short_name}}</div>
          <div class="type">{{item.market_name}}</div>
        </div>
        <div class="line-detail">
          <div class="time">{{item.publish_time | timeTrans}}</div>
          <div class="status">{{item.status_name}}</div>
        </div>
      </div>
    </div>
    <button class="more-prospectus" @click="goMore">查看更多</button>
  </div>
</template>
<script>
import { prospectusList } from '@/service.js'
import filter from 'js/filter'
import { listMixins } from 'js/listMixins'
export default {
  inject: ['haddleApplyTry2'],
  mixins: [listMixins],
  data() {
    return {
      list: []
    }
  },
  computed: {
    market() {
      return function(key) {
        return this.meta.zgs_market ? this.meta.zgs_market[key] : '--'
      }
    },
  },
  created() {
    this.getMeta2(['zgs_market', 'zgs_status'])
  },
  beforeMount() {
    this.prospectusList()
  },
  methods: {
    //获取招股书列表
    async prospectusList() {
      let res = await prospectusList((error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        this.list = res.res
        this.list.map(item => {
          this.$set(item, 'status_name', filter.empty(this.meta.zgs_status[item.status]))
          this.$set(item, 'market_name', filter.empty(this.market(item.market)))
        })
      }
    },
    //跳转至招股书列表页
    goMore() {
      const { href } = this.$router.resolve({ name: 'ProspectusList'})
      window.open(href, '_blank')
      _czc.push(['_trackEvent', '看赛道(新)', '招股书(查看更多)', '点击量'])
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common_track.stylus'
.header
  .right
    display flex
    align-items center
    font-size 12px
    img
      height 16px
      margin 0 2px
.porspectus-list
  margin-top 18px
  font-family PingFang SC
  font-weight 500
  padding 0 5px
  .porspectus-item
    line-height 20px
    &:not(:first-child)
      margin-top 10px
    &:not(:last-child)
      padding-bottom 16px
      border-bottom 1px solid #EEEEEE
    .line1
      display flex
      align-items center
      justify-content space-between
      .name
        flex 0 0 263px
        font-size 14px
        color #333333
        display inline-block
      .browser
        display inline-block
        color #FF8824
        cursor pointer
        &:hover
          color #FF6600
    .line-detail
      margin-top 6px
      font-size 13px
      color #666666
      display flex
      justify-content space-between
.more-prospectus
  width 100%
  height 36px
  margin-top 23px
  border 1px solid #FF8824
  background none
  color #ff8824
  font-size 14px
  cursor pointer
  &:hover
    color #FF6600
    border 1px solid #FF6600

</style>
